// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0.226318 4H17.2263V8.43381L24.2263 4.23381V19.7662L17.2263 15.5662V20H0.226318V4Z"}}]};

const VideoCameraFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-filled',
    ref,
    icon: element,
  },
));

VideoCameraFilledIcon.displayName = 'VideoCameraFilledIcon';

export default VideoCameraFilledIcon;
